import { render, staticRenderFns } from "./SocialSharingControl.vue?vue&type=template&id=1fbab8d9"
import script from "./SocialSharingControl.vue?vue&type=script&lang=js"
export * from "./SocialSharingControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports